import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'
import ToggleButton, * as ToggleButtonLabels from '../../components/ToggleButton'

import * as StepLabels from '../../constants/StepLabels'

import {ToggleSelection, ToggleSelectionButtons, ToggleSelectionContents} from '../util/ToggleSelection'
import FloatingContent from '../../components/FloatingContent'
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from '../../components/navigation/StepControlButton'

import {getActualBillingAddressSmall, getActualEmailAddress} from '../../selectors/Forms'


import SepaForm from './SepaForm'
import AlternateSepaForm from './AlternateSepaForm'
import {forceValidationOnSteps} from "../../actions/StepControl";
import {toggleAlternateSepaInput} from "../../actions/AlternateSepaInput";
import {putFormData} from "../../actions/FormData";
import BillingPeriodGroup from "../configuration/BillingPeriodGroup";
import {isPaymentSettingsValid} from "../../selectors/StepValidation";
import {getBaseArticle} from "../../selectors/SimpleSelectors";
import {delve} from "../../util/util";
import {INVOICE_TYPE_EMAIL, INVOICE_TYPE_POST, PAYMENT_TYPE_INVOICE, PAYMENT_TYPE_SEPA} from "../../constants/General";

class PaymentStep extends Component {

    static propTypes = {
        stepLabel: PropTypes.string.isRequired,
        nextLabel: PropTypes.string.isRequired,
        prevLabel: PropTypes.string.isRequired,
        onButtonNextClick: PropTypes.func,
        onButtonPrevClick: PropTypes.func
    }

    handleButtonNextClick = (e) => {

        if (!this.props.isPaymentSettingsValid) {
            this.props.forceValidation()
        }

        if (this.props.isPaymentSettingsValid && !this.props.isFetchingFormData) {
            this.props.onButtonNextClick()
        }

    }

    onInvoiceTypeSelect = (invoiceType) => {
        this.props.putFormData()
    }

    onPaymentTypeSelect = (paymentType) => {
        this.props.putFormData()
    }

    componentWillLeave = () => {
        if (window.getSelection) {
            if (window.getSelection().empty) {  // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {  // Firefox
                window.getSelection().removeAllRanges();
            }
        } else if (document.selection) {  // IE?
            document.selection.empty();
        }

        if (!this.props.isFetchingFormData) {
            this.props.putFormData()
        }
    }

    render() {

        const addressShort = this.props.addressFormatSmall.join('\n')
        const email = this.props.email

        return (
            <div className="step-display__page payment-step">

                <h2>Zahlungsart</h2>

                <ToggleSelection id="billingType" onSelect={this.onPaymentTypeSelect}>
                    <ToggleSelectionButtons>
                        <ToggleButton target={PAYMENT_TYPE_SEPA} buttonLabel="Lastschrift" align="left"/>
                        <ToggleButton target={PAYMENT_TYPE_INVOICE} buttonLabel="Rechnung" align="right"/>
                    </ToggleSelectionButtons>
                    <ToggleSelectionContents>
                        {!this.props.isAlternateSepaInput ?
                            <FloatingContent key={PAYMENT_TYPE_SEPA} align="left">
                                <SepaForm
                                    forceValidation={this.props.forcedValidationSteps.includes(StepLabels.PAYMENT)}/>
                                <a href={'#'} onClick={this.props.toggleAlternateSepaInput}
                                   className="payment-step__alternate-input-cta">Kontonummer & Bankleitzahl eingeben</a>
                            </FloatingContent> :
                            <FloatingContent key={PAYMENT_TYPE_SEPA} align="left">
                                <AlternateSepaForm
                                    forceValidation={this.props.forcedValidationSteps.includes(StepLabels.PAYMENT)}/>
                                <a href={'#'} onClick={this.props.toggleAlternateSepaInput}
                                   className="payment-step__alternate-input-cta">IBAN & BIC eingeben</a>
                            </FloatingContent>}
                    </ToggleSelectionContents>
                </ToggleSelection>

                <h2>Rechnungsversand</h2>

                <ToggleSelection id="invoiceType" onSelect={this.onInvoiceTypeSelect}>
                    <ToggleSelectionButtons>
                        <ToggleButton target={INVOICE_TYPE_EMAIL}
                                      theme={ToggleButtonLabels.THEME_BLOCK_DESCRIPTION} description={email}
                                      hint="kostenfrei" buttonLabel="Per E-Mail" align="left"/>
                        <ToggleButton target={INVOICE_TYPE_POST}
                                      theme={ToggleButtonLabels.THEME_BLOCK_DESCRIPTION} description={addressShort}
                                      hint="+1 € zzgl. USt.*" buttonLabel="Per Post" align="right"/>
                    </ToggleSelectionButtons>
                </ToggleSelection>

                {this.props.baseArticle && delve(this.props.baseArticle, "billing.allowDurationModification") ? <BillingPeriodGroup/> : null}

                <div className="step-display__page__control">
                    {this.props.prevLabel !== "" ? <StepControlButton type={CONTROL_PREV} label={this.props.prevLabel}
                                                                      onClick={this.props.onButtonPrevClick}/> : null}
                    {this.props.nextLabel !== "" ?
                        <StepControlButton type={CONTROL_NEXT} disabled={!this.props.isPaymentSettingsValid}
                                           label={this.props.nextLabel} onClick={this.handleButtonNextClick}/> : null}

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        addressFormatSmall: getActualBillingAddressSmall(state),
        email: getActualEmailAddress(state),
        isFetchingFormData: state.appState.isFetchingFormData,
        isPaymentSettingsValid: isPaymentSettingsValid(state),
        forcedValidationSteps: state.ui.forcedValidationSteps,
        isAlternateSepaInput: state.paymentStep.isAlternateSepaInput,
        baseArticle: getBaseArticle(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        putFormData: () => {
            setTimeout(() => {
                dispatch(putFormData())
            }, 100)
        },
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        },
        toggleAlternateSepaInput: (e) => {
            e.preventDefault();
            dispatch(toggleAlternateSepaInput())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(PaymentStep)



/** WEBPACK FOOTER **
 ** ./src/containers/payment/PaymentStep.js
 **/